import { render, staticRenderFns } from "./nazionalita.vue?vue&type=template&id=7f70704e&"
import script from "./nazionalita.vue.ts?vue&type=script&lang=ts&"
export * from "./nazionalita.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports